module.exports = __webpack_public_path__ + "static/media/guide_img1_5.59feb17f.png";